
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  detectRuntime,
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.6.0
 * Query Engine version: e95e739751f42d8ca026f6b910f5a2dc5adeaeee
 */
Prisma.prismaVersion = {
  client: "5.6.0",
  engine: "e95e739751f42d8ca026f6b910f5a2dc5adeaeee"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UsersScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  username: 'username',
  firstName: 'firstName',
  babyName: 'babyName',
  email: 'email',
  contactNumber: 'contactNumber',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  postcode: 'postcode',
  country: 'country',
  lastName: 'lastName',
  title: 'title',
  role: 'role',
  termsAccepted: 'termsAccepted',
  stripe_customer_id: 'stripe_customer_id',
  stripe_subscription_id: 'stripe_subscription_id',
  stripe_price_id: 'stripe_price_id',
  is_admin: 'is_admin'
};

exports.Prisma.OrderScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  created_at: 'created_at',
  status: 'status',
  delivery_date: 'delivery_date',
  delivery_status: 'delivery_status',
  return_date: 'return_date',
  subscription_type: 'subscription_type',
  internal_note: 'internal_note',
  stripe_subscription_id: 'stripe_subscription_id',
  delivery_date_time: 'delivery_date_time',
  return_date_time: 'return_date_time',
  checkout_id: 'checkout_id',
  ignore_stock_update: 'ignore_stock_update',
  delivery_provider: 'delivery_provider',
  delivery_tracking_number: 'delivery_tracking_number'
};

exports.Prisma.Order_giftingScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  status: 'status',
  delivery_date: 'delivery_date',
  delivery_status: 'delivery_status',
  title_sender: 'title_sender',
  first_name_sender: 'first_name_sender',
  last_name_sender: 'last_name_sender',
  email_sender: 'email_sender',
  phone_sender: 'phone_sender',
  title_recipient: 'title_recipient',
  first_name_recipient: 'first_name_recipient',
  last_name_recipient: 'last_name_recipient',
  email_recipient: 'email_recipient',
  phone_recipient: 'phone_recipient',
  message: 'message',
  stripe_id: 'stripe_id',
  coupon_id: 'coupon_id',
  coupon_value: 'coupon_value',
  internal_note: 'internal_note'
};

exports.Prisma.Order_product_variantsScalarFieldEnum = {
  product_variant_id: 'product_variant_id',
  created_at: 'created_at',
  id: 'id',
  order_id: 'order_id'
};

exports.Prisma.Product_tagsScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  product_id: 'product_id',
  tag_id: 'tag_id'
};

exports.Prisma.Product_variant_stock_updatesScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  product_variant_id: 'product_variant_id',
  order_id: 'order_id',
  new_stock: 'new_stock',
  old_stock: 'old_stock'
};

exports.Prisma.Product_variantsScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  product_id: 'product_id',
  sku: 'sku',
  rrp: 'rrp',
  stock: 'stock',
  updated_at: 'updated_at',
  static_stock: 'static_stock',
  deleted_at: 'deleted_at',
  size_id: 'size_id',
  color_id: 'color_id',
  acs_id: 'acs_id',
  lifespan_base: 'lifespan_base'
};

exports.Prisma.ProductsScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  name: 'name',
  product_reference: 'product_reference',
  images: 'images',
  description: 'description',
  published_at: 'published_at',
  slug: 'slug',
  updated_at: 'updated_at',
  accordion1: 'accordion1',
  accordion2: 'accordion2',
  accordion3: 'accordion3',
  orderKey: 'orderKey',
  accordion1_title: 'accordion1_title',
  accordion2_title: 'accordion2_title',
  accordion3_title: 'accordion3_title',
  rrp: 'rrp',
  deleted_at: 'deleted_at',
  archived_at: 'archived_at'
};

exports.Prisma.TagsScalarFieldEnum = {
  id: 'id',
  name: 'name',
  type: 'type',
  slug: 'slug',
  created_at: 'created_at',
  order: 'order',
  lifespan_impact: 'lifespan_impact'
};

exports.Prisma.Api_logsScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  origin: 'origin',
  note: 'note',
  status: 'status',
  last_id_synced: 'last_id_synced'
};

exports.Prisma.Product_items_historyScalarFieldEnum = {
  id: 'id',
  product_item_id: 'product_item_id',
  previous_status: 'previous_status',
  new_status: 'new_status',
  previous_order_id: 'previous_order_id',
  new_order_id: 'new_order_id',
  new_return_id: 'new_return_id',
  changed_by_user_id: 'changed_by_user_id',
  change_reason: 'change_reason',
  createdAt: 'createdAt'
};

exports.Prisma.User_product_favoritesScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  product_id: 'product_id',
  user_id: 'user_id'
};

exports.Prisma.Variant_optionsScalarFieldEnum = {
  id: 'id',
  name: 'name',
  type: 'type',
  slug: 'slug',
  metadata: 'metadata',
  order: 'order'
};

exports.Prisma.Product_itemsScalarFieldEnum = {
  id: 'id',
  created_at: 'created_at',
  expired_at: 'expired_at',
  orId: 'orId',
  sku: 'sku',
  barcode: 'barcode',
  history_big_days_user: 'history_big_days_user',
  status: 'status',
  base_history_days: 'base_history_days',
  product_variant_id: 'product_variant_id',
  acs_rfid: 'acs_rfid',
  history_rental_homes: 'history_rental_homes',
  wholesale_price: 'wholesale_price',
  rental_homes: 'rental_homes',
  sold_price: 'sold_price'
};

exports.Prisma.User_product_itemsScalarFieldEnum = {
  id: 'id',
  product_item_id: 'product_item_id',
  partial_order_id: 'partial_order_id',
  user_id: 'user_id',
  partial_return_id: 'partial_return_id',
  product_variant_id: 'product_variant_id'
};

exports.Prisma.Product_item_retirementScalarFieldEnum = {
  id: 'id',
  product_item_id: 'product_item_id',
  date: 'date',
  reason: 'reason',
  acs_retirement_id: 'acs_retirement_id'
};

exports.Prisma.Partial_orderScalarFieldEnum = {
  id: 'id',
  date: 'date',
  status: 'status',
  user_id: 'user_id',
  stripe_checkout_id: 'stripe_checkout_id',
  internal_note: 'internal_note',
  delivery_provider: 'delivery_provider',
  acs_order_id: 'acs_order_id',
  acs_processed_time: 'acs_processed_time',
  created_at: 'created_at',
  original_product_item_ids: 'original_product_item_ids',
  acs_error: 'acs_error',
  dispatched_at: 'dispatched_at',
  tracking_code: 'tracking_code',
  acs_updated_at: 'acs_updated_at'
};

exports.Prisma.Partial_returnScalarFieldEnum = {
  id: 'id',
  date: 'date',
  status: 'status',
  user_id: 'user_id',
  internal_note: 'internal_note',
  delivery_provider: 'delivery_provider',
  acs_processed_time: 'acs_processed_time',
  acs_return_id: 'acs_return_id',
  created_at: 'created_at',
  item_quantity: 'item_quantity',
  cancellation_reason: 'cancellation_reason',
  original_product_item_ids: 'original_product_item_ids'
};

exports.Prisma.Product_items_with_statsScalarFieldEnum = {
  id: 'id',
  orId: 'orId',
  sku: 'sku',
  name: 'name',
  sold_price: 'sold_price',
  product_id: 'product_id',
  status: 'status',
  wholesale_price: 'wholesale_price',
  resale_value: 'resale_value',
  rental_homes: 'rental_homes',
  barcode: 'barcode',
  launch_date: 'launch_date',
  current_rental_user_email: 'current_rental_user_email',
  brand_tag: 'brand_tag',
  category_tags_arr: 'category_tags_arr',
  sleeve_length_tags_arr: 'sleeve_length_tags_arr',
  season_tags_arr: 'season_tags_arr',
  concept_tags_arr: 'concept_tags_arr',
  type_tags_arr: 'type_tags_arr',
  current_rental_start: 'current_rental_start',
  weeks_live: 'weeks_live',
  history_rental_weeks: 'history_rental_weeks',
  lifespan: 'lifespan',
  planned_rental_value: 'planned_rental_value',
  total_rental_value: 'total_rental_value',
  margin_vs_plan_value: 'margin_vs_plan_value',
  product_item_created_at: 'product_item_created_at',
  planned_margin: 'planned_margin',
  current_rental_weeks: 'current_rental_weeks',
  total_rental_weeks: 'total_rental_weeks',
  avg_rental_weeks_per_user: 'avg_rental_weeks_per_user',
  efficiency: 'efficiency',
  wp_covered: 'wp_covered',
  color_id: 'color_id',
  size_id: 'size_id',
  rrp: 'rrp'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.usersOrderByRelevanceFieldEnum = {
  id: 'id',
  username: 'username',
  firstName: 'firstName',
  babyName: 'babyName',
  email: 'email',
  contactNumber: 'contactNumber',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  postcode: 'postcode',
  country: 'country',
  lastName: 'lastName',
  title: 'title',
  role: 'role',
  stripe_customer_id: 'stripe_customer_id',
  stripe_subscription_id: 'stripe_subscription_id',
  stripe_price_id: 'stripe_price_id'
};

exports.Prisma.orderOrderByRelevanceFieldEnum = {
  user_id: 'user_id',
  status: 'status',
  delivery_date: 'delivery_date',
  delivery_status: 'delivery_status',
  return_date: 'return_date',
  subscription_type: 'subscription_type',
  internal_note: 'internal_note',
  stripe_subscription_id: 'stripe_subscription_id',
  checkout_id: 'checkout_id',
  delivery_provider: 'delivery_provider',
  delivery_tracking_number: 'delivery_tracking_number'
};

exports.Prisma.order_giftingOrderByRelevanceFieldEnum = {
  status: 'status',
  delivery_date: 'delivery_date',
  delivery_status: 'delivery_status',
  title_sender: 'title_sender',
  first_name_sender: 'first_name_sender',
  last_name_sender: 'last_name_sender',
  email_sender: 'email_sender',
  phone_sender: 'phone_sender',
  title_recipient: 'title_recipient',
  first_name_recipient: 'first_name_recipient',
  last_name_recipient: 'last_name_recipient',
  email_recipient: 'email_recipient',
  phone_recipient: 'phone_recipient',
  message: 'message',
  stripe_id: 'stripe_id',
  coupon_id: 'coupon_id',
  coupon_value: 'coupon_value',
  internal_note: 'internal_note'
};

exports.Prisma.product_variantsOrderByRelevanceFieldEnum = {
  sku: 'sku',
  acs_id: 'acs_id'
};

exports.Prisma.productsOrderByRelevanceFieldEnum = {
  name: 'name',
  product_reference: 'product_reference',
  images: 'images',
  description: 'description',
  slug: 'slug',
  accordion1: 'accordion1',
  accordion2: 'accordion2',
  accordion3: 'accordion3',
  orderKey: 'orderKey',
  accordion1_title: 'accordion1_title',
  accordion2_title: 'accordion2_title',
  accordion3_title: 'accordion3_title'
};

exports.Prisma.tagsOrderByRelevanceFieldEnum = {
  name: 'name',
  type: 'type',
  slug: 'slug'
};

exports.Prisma.api_logsOrderByRelevanceFieldEnum = {
  note: 'note'
};

exports.Prisma.product_items_historyOrderByRelevanceFieldEnum = {
  previous_status: 'previous_status',
  new_status: 'new_status',
  change_reason: 'change_reason'
};

exports.Prisma.user_product_favoritesOrderByRelevanceFieldEnum = {
  user_id: 'user_id'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.variant_optionsOrderByRelevanceFieldEnum = {
  name: 'name',
  type: 'type',
  slug: 'slug'
};

exports.Prisma.product_itemsOrderByRelevanceFieldEnum = {
  orId: 'orId',
  sku: 'sku',
  barcode: 'barcode',
  acs_rfid: 'acs_rfid'
};

exports.Prisma.user_product_itemsOrderByRelevanceFieldEnum = {
  user_id: 'user_id'
};

exports.Prisma.product_item_retirementOrderByRelevanceFieldEnum = {
  reason: 'reason'
};

exports.Prisma.partial_orderOrderByRelevanceFieldEnum = {
  user_id: 'user_id',
  stripe_checkout_id: 'stripe_checkout_id',
  internal_note: 'internal_note',
  delivery_provider: 'delivery_provider',
  acs_order_id: 'acs_order_id',
  original_product_item_ids: 'original_product_item_ids',
  acs_error: 'acs_error',
  dispatched_at: 'dispatched_at',
  tracking_code: 'tracking_code'
};

exports.Prisma.partial_returnOrderByRelevanceFieldEnum = {
  user_id: 'user_id',
  internal_note: 'internal_note',
  delivery_provider: 'delivery_provider',
  acs_return_id: 'acs_return_id',
  cancellation_reason: 'cancellation_reason',
  original_product_item_ids: 'original_product_item_ids'
};

exports.Prisma.product_items_with_statsOrderByRelevanceFieldEnum = {
  orId: 'orId',
  sku: 'sku',
  name: 'name',
  barcode: 'barcode',
  current_rental_user_email: 'current_rental_user_email',
  brand_tag: 'brand_tag',
  category_tags_arr: 'category_tags_arr',
  sleeve_length_tags_arr: 'sleeve_length_tags_arr',
  season_tags_arr: 'season_tags_arr',
  concept_tags_arr: 'concept_tags_arr',
  type_tags_arr: 'type_tags_arr'
};
exports.ApiLogOrigins = exports.$Enums.ApiLogOrigins = {
  stockSync: 'stockSync',
  orderSync: 'orderSync',
  returnSync: 'returnSync',
  acsCreateOrder: 'acsCreateOrder',
  retirementSync: 'retirementSync'
};

exports.ApiLogStatus = exports.$Enums.ApiLogStatus = {
  SUCCESS: 'SUCCESS',
  NEW_STOCK: 'NEW_STOCK',
  NO_UPDATE: 'NO_UPDATE',
  ERROR: 'ERROR'
};

exports.ProductItemStatus = exports.$Enums.ProductItemStatus = {
  INITIATED: 'INITIATED',
  STORAGE: 'STORAGE',
  HOLD: 'HOLD',
  STORAGE_APPROVE: 'STORAGE_APPROVE',
  STORAGE_HOLD: 'STORAGE_HOLD',
  CUSTOMER: 'CUSTOMER',
  RETURNING: 'RETURNING',
  IN_CLEANING: 'IN_CLEANING',
  PROBLEM: 'PROBLEM',
  RESALE: 'RESALE',
  EX_HIRE: 'EX_HIRE',
  SOLD: 'SOLD'
};

exports.OrderStatus = exports.$Enums.OrderStatus = {
  ORDER_PROBLEM: 'ORDER_PROBLEM',
  ORDER_FINALISED: 'ORDER_FINALISED',
  ORDER_PLACED: 'ORDER_PLACED',
  ORDER_ACTIVE: 'ORDER_ACTIVE',
  ORDER_PLACED_PAYMENT_CANCELLED: 'ORDER_PLACED_PAYMENT_CANCELLED',
  ORDER_PLACED_PAYMENT_PENDING: 'ORDER_PLACED_PAYMENT_PENDING',
  ORDER_PROCESSING: 'ORDER_PROCESSING'
};

exports.Prisma.ModelName = {
  users: 'users',
  order: 'order',
  order_gifting: 'order_gifting',
  order_product_variants: 'order_product_variants',
  product_tags: 'product_tags',
  product_variant_stock_updates: 'product_variant_stock_updates',
  product_variants: 'product_variants',
  products: 'products',
  tags: 'tags',
  api_logs: 'api_logs',
  product_items_history: 'product_items_history',
  user_product_favorites: 'user_product_favorites',
  variant_options: 'variant_options',
  product_items: 'product_items',
  user_product_items: 'user_product_items',
  product_item_retirement: 'product_item_retirement',
  partial_order: 'partial_order',
  partial_return: 'partial_return',
  product_items_with_stats: 'product_items_with_stats'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        const runtime = detectRuntime()
        const edgeRuntimeName = {
          'workerd': 'Cloudflare Workers',
          'deno': 'Deno and Deno Deploy',
          'netlify': 'Netlify Edge Functions',
          'edge-light': 'Vercel Edge Functions',
        }[runtime]

        let message = 'PrismaClient is unable to run in '
        if (edgeRuntimeName !== undefined) {
          message += edgeRuntimeName + '. As an alternative, try Accelerate: https://pris.ly/d/accelerate.'
        } else {
          message += 'this browser environment, or has been bundled for the browser (running in `' + runtime + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://github.com/prisma/prisma/issues`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
